/* eslint-disable react/prop-types */
interface ControlsSectionProps {
  availableFilter: 'all' | 'weekdays' | 'weekends';
  selectedDaysOfWeek: number[];
  handleDayOfWeekToggle: (dayIndex: number) => void;
  handleAvailableFilterChange: (filter: 'all' | 'weekdays' | 'weekends') => void;
  statusViewFilter: 'available' | 'busy' | 'both';
  setStatusViewFilter: (filter: 'available' | 'busy' | 'both') => void;
}

const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export const CalendarControls: React.FC<ControlsSectionProps> = ({
  availableFilter,
  selectedDaysOfWeek,
  handleDayOfWeekToggle,
  handleAvailableFilterChange,
  statusViewFilter,
  setStatusViewFilter,
}) => {
  return (
    <div className="h-full rounded-lg border border-gray-200 bg-gray-50 p-4 dark:border-neutral-700 dark:bg-neutral-900 md:h-auto">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-center lg:gap-x-8">
        {/* Filter Group: All, Weekdays, Weekends */}
        <div className="flex justify-center">
          <button
            className={`relative rounded-l-md border px-4 py-2 text-sm font-semibold transition-all duration-200 ${
              availableFilter === 'all'
                ? 'z-10 border-transparent bg-gradient-to-br from-pink-500 to-purple-600 text-white'
                : 'border-gray-300 bg-transparent text-gray-500 hover:bg-gray-100 dark:border-neutral-700 dark:text-gray-400 dark:hover:bg-neutral-800'
            }`}
            onClick={() => handleAvailableFilterChange('all')}
          >
            All
          </button>
          <button
            className={`relative -ml-px border px-4 py-2 text-sm font-semibold transition-all duration-200 ${
              availableFilter === 'weekdays'
                ? 'z-10 border-transparent bg-gradient-to-br from-pink-500 to-purple-600 text-white'
                : 'border-gray-300 bg-transparent text-gray-500 hover:bg-gray-100 dark:border-neutral-700 dark:text-gray-400 dark:hover:bg-neutral-800'
            }`}
            onClick={() => handleAvailableFilterChange('weekdays')}
          >
            Weekdays
          </button>
          <button
            className={`relative -ml-px rounded-r-md border px-4 py-2 text-sm font-semibold transition-all duration-200 ${
              availableFilter === 'weekends'
                ? 'z-10 border-transparent bg-gradient-to-br from-pink-500 to-purple-600 text-white'
                : 'border-gray-300 bg-transparent text-gray-500 hover:bg-gray-100 dark:border-neutral-700 dark:text-gray-400 dark:hover:bg-neutral-800'
            }`}
            onClick={() => handleAvailableFilterChange('weekends')}
          >
            Weekends
          </button>
        </div>

        {/* Day of Week Buttons */}
        <div className="mt-4 flex justify-center lg:mt-0">
          {dayNames.map((name, idx) => (
            <button
              key={name}
              className={`relative border px-3 py-2 text-sm font-semibold transition-all duration-200 ${
                idx === 0 ? 'rounded-l-md' : ''
              } ${idx === dayNames.length - 1 ? 'rounded-r-md' : ''} ${idx !== 0 ? '-ml-px' : ''} ${
                selectedDaysOfWeek.includes(idx)
                  ? 'z-10 border-transparent bg-gradient-to-br from-pink-500 to-purple-600 text-white'
                  : 'border-gray-300 bg-transparent text-gray-500 hover:bg-gray-100 dark:border-neutral-700 dark:text-gray-400 dark:hover:bg-neutral-800'
              }`}
              onClick={() => handleDayOfWeekToggle(idx)}
            >
              <span className="hidden lg:inline">{name}</span>
              <span className="lg:hidden">{name.charAt(0)}</span>
            </button>
          ))}
        </div>

        {/* Status Filter Bar */}
        <div className="mt-4 flex justify-center lg:mt-0">
          <button
            className={`rounded-l-md border px-4 py-2 text-sm font-semibold transition-all duration-200 ${
              statusViewFilter === 'available'
                ? 'z-10 border-transparent bg-gradient-to-br from-pink-500 to-purple-600 text-white'
                : 'border-gray-300 bg-transparent text-gray-500 hover:bg-gray-100 dark:border-neutral-700 dark:text-gray-400 dark:hover:bg-neutral-800'
            }`}
            onClick={() => setStatusViewFilter('available')}
          >
            Available
          </button>
          <button
            className={`-ml-px border px-4 py-2 text-sm font-semibold transition-all duration-200 ${
              statusViewFilter === 'busy'
                ? 'z-10 border-transparent bg-gradient-to-br from-pink-500 to-purple-600 text-white'
                : 'border-gray-300 bg-transparent text-gray-500 hover:bg-gray-100 dark:border-neutral-700 dark:text-gray-400 dark:hover:bg-neutral-800'
            }`}
            onClick={() => setStatusViewFilter('busy')}
          >
            Busy
          </button>
          <button
            className={`-ml-px rounded-r-md border px-4 py-2 text-sm font-semibold transition-all duration-200 ${
              statusViewFilter === 'both'
                ? 'z-10 border-transparent bg-gradient-to-br from-pink-500 to-purple-600 text-white'
                : 'border-gray-300 bg-transparent text-gray-500 hover:bg-gray-100 dark:border-neutral-700 dark:text-gray-400 dark:hover:bg-neutral-800'
            }`}
            onClick={() => setStatusViewFilter('both')}
          >
            Both
          </button>
        </div>
      </div>
    </div>
  );
};
